module.exports = __webpack_public_path__ + "static/media/gongxiangdanche.f592ad9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/gongxiangdanche.mp3
// module id = gHrs
// module chunks = 208